<div (click)="remove()" (mouseenter)="pause()" (mouseleave)="unPause()" [ngClass]="notification.level"
     class="container-notification">
  <div class="content-notif"> {{notification.text}} </div>
  <button class="cross" title="dismiss" type="button">
    <img loading="lazy" alt="Fermer la notification" src="/assets/images/cross.svg?v=2"/>
  </button>
</div>
